;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .controller('AgileCentralIntegrationCtrl', AgileCentralIntegrationCtrl)

  function AgileCentralIntegrationCtrl(
    $scope,
    $q,
    $location,
    $routeParams,
    $translate,
    ServiceUtils,
    integrationService,
    UserService,
    rulesBugtrackerService,
    AgileCentralBugtrackerService,
    ApplicationFactory,
    BugtrackerCredentialsService,
    INTEGRATION_TYPE,
    AGILE_CENTRAL_PROPERTIES
  ) {
    'ngInject'

    var agileCentralId = $routeParams.agileCentralId
    var allApplications, allRules
    var _allOptionValue = 'All'
    var rules = []

    var errorOptions = {
      timeOut: 0,
      extendedTimeOut: 0,
      tapToDismiss: false,
      progressBar: false,
      dismissOnTimeout: false,
      dismissOnClick: false,
      dismissButton: true
    }

    angular.extend($scope, {
      errorCode: undefined,
      errorMsgs: [],
      fieldErrors: [],
      adding: false,
      configurationLoaded: false,
      environmentId: undefined,
      stateId: undefined,
      priorityId: undefined,
      model: {
        name: '',

        credentials: undefined,
        isCredentialsUpdate: false,
        credentialsId: '',

        host: '',
        username: '',
        password: '',

        applications: [],
        all_applications: false,

        integration: false,
        generating_url: false,
        url: undefined,
        integrations: [],

        auto_create_tickets_enabled: false,
        auto_create_tickets_rules: [],
        auto_create_tickets_severities: [],
        auto_create_tickets_all_rules: false,
        placeholderURL: 'http://agile.central.hostname.com/'
      },
      properties: {
        fields: []
      },
      hasPreviousCredentials: false,
      allowEditCredentials: false,
      forceNewSetCreation: false,
      applicationsPromise: undefined,
      rulesPromise: undefined,
      latestCredentialsPromise: undefined,
      credentialsListPromise: undefined,
      loadPromise: undefined,
      isEdit: false,
      autoCreateTicketsEnabled: false,
      showInvalidConnection: false,
      showValidConnection: false,
      isUrlTested: false,
      projectSelected: false,
      select: {
        credentials: [],
        applications: [],
        projects: [],
        rules: [],
        users: [],
        priorities: [],
        environments: [],
        states: []
      },
      integrationPromise: undefined
    })

    angular.extend($scope, {
      save: save,
      cancelCreation: cancelCreation,
      testConnection: testConnection,
      getApplications: getApplications,
      getIntegration: getIntegration,
      validForm: validForm,
      resetConnection: resetConnection,
      createIntegration: createIntegration,
      updateIntegration: updateIntegration,
      deleteIntegration: deleteIntegration,

      onApplicationsUpdated: onApplicationsUpdated,
      onApplicationsDeleted: onApplicationsDeleted,
      onRulesUpdated: onRulesUpdated,
      onRulesDeleted: onRulesDeleted,
      updateMultiSelect: updateMultiSelect,
      deleteMultiSelect: deleteMultiSelect,
      enableAutoCreateTickets: enableAutoCreateTickets,

      onChangeProject: onChangeProject,
      onUserInputChange: onUserInputChange,
      onUserSelect: onUserSelect,

      manageCredentials: manageCredentials,
      onChangeCredentials: onChangeCredentials,
      onCredentialsInputChange: onCredentialsInputChange,
      onUrlSelectChange: onUrlSelectChange
    })

    function init() {
      $scope.applicationsPromise = getApplications()
      $scope.rulesPromise = _getRules()

      $q.all([$scope.applicationsPromise, $scope.rulesPromise]).then(
        function () {
          _populateRulesCombobox()

          if (agileCentralId) {
            $scope.isEdit = true
            $scope.integrationPromise = getIntegration()
            $q.all([$scope.integrationPromise]).then(function () {
              $scope.model.applications = []

              var selectedApps = _.filter(
                $scope.select.applications,
                function (app) {
                  return _.includes($scope.selected_appids, app.app_id)
                }
              )

              if ($scope.model.all_applications || selectedApps.length == 0) {
                $scope.model.applications.push(allApplications)
                $scope.model.all_applications = true
              } else {
                $scope.model.applications = selectedApps
                $scope.model.all_applications = false
              }

              if ($scope.model.auto_create_tickets_enabled) {
                $scope.autoCreateTicketsEnabled = true
                $scope.model.auto_create_tickets_rules =
                  rulesBugtrackerService.buildRules(
                    $scope.model.auto_create_tickets_rules,
                    $scope.model.auto_create_tickets_severities
                  )
                _setAutoCreateTicketsEnabled()
              } else {
                _setDefaultSeveritiesAsRules()
              }
            })
          } else {
            $scope.latestCredentialsPromise = _getLatestUsedCredentials()
            _setDefaultSeveritiesAsRules()
          }
        }
      )
    }

    function onApplicationsUpdated() {
      updateMultiSelect($scope.model.applications)
      $scope.model.all_applications = false
    }

    function onApplicationsDeleted() {
      $scope.model.all_applications = deleteMultiSelect(
        $scope.model.applications,
        allApplications
      )
    }

    function onRulesUpdated() {
      _updateRulesMultiSelect($scope.model.auto_create_tickets_rules)
      $scope.model.auto_create_tickets_all_rules = false
    }

    function onRulesDeleted() {
      $scope.model.auto_create_tickets_all_rules = deleteMultiSelect(
        $scope.model.auto_create_tickets_rules,
        allRules
      )
    }

    function updateMultiSelect(array) {
      var index = _.findIndex(array, function (item) {
        return item.app_id === _allOptionValue
      })

      if (index !== -1) {
        array.splice(index, 1)
      }
    }

    function _updateRulesMultiSelect(array) {
      var index = _.findIndex(array, function (item) {
        return item.value === _allOptionValue
      })

      if (index !== -1) {
        array.splice(index, 1)
      }
    }

    function deleteMultiSelect(array, allOption) {
      if (array.length == 0) {
        array.push(allOption)
        return true
      } else {
        return false
      }
    }

    function enableAutoCreateTickets() {
      $scope.model.auto_create_tickets_enabled =
        !$scope.model.auto_create_tickets_enabled
      if ($scope.model.auto_create_tickets_enabled) {
        _setAutoCreateTicketsEnabled()
      }
    }

    function _getRules() {
      return rulesBugtrackerService.getRules().then(function (rulesFound) {
        rules = rulesFound
        allRules = {
          name:
            $translate.instant('title_allRules') +
            ' (' +
            rulesFound.length +
            ')',
          value: _allOptionValue
        }
      })
    }

    function _populateRulesCombobox() {
      $scope.select.rules =
        rulesBugtrackerService.buildRulesWithAllSeverities(rules)
    }

    function _setDefaultSeveritiesAsRules() {
      var defaultSeverities = angular.copy(
        rulesBugtrackerService.buildRulesWithDefaultSeverities()
      )

      $scope.model.auto_create_tickets_rules = []
      $scope.model.auto_create_tickets_severities = []
      $scope.model.auto_create_tickets_all_rules = false

      _.each(defaultSeverities, function (severity) {
        $scope.model.auto_create_tickets_rules.push(severity)
      })
    }

    function _setAutoCreateTicketsEnabled() {
      if ($scope.model.auto_create_tickets_all_rules) {
        _setAutoCreateTicketsEnabledWithAllRules()
      } else {
        _setAutoCreateTicketsEnabledWithCustomizedRules()
      }
    }

    function _setAutoCreateTicketsEnabledWithAllRules() {
      $scope.model.auto_create_tickets_rules = [allRules]
      $scope.model.auto_create_tickets_severities = []
      $scope.model.auto_create_tickets_all_rules = true
    }

    function _setAutoCreateTicketsEnabledWithCustomizedRules() {
      $scope.model = AgileCentralBugtrackerService.transformToIntegrationView(
        $scope.model,
        $scope.select.rules
      )
    }

    function validForm() {
      return (
        _validForm() &&
        !$scope.testing &&
        !$scope.showInvalidConnection &&
        $scope.showValidConnection &&
        $scope.configurationLoaded
      )
    }

    function _invalidCredentials() {
      return (
        (!$scope.allowEditCredentials &&
          !$scope.model.credentialsId &&
          $scope.hasPreviousCredentials) ||
        (($scope.allowEditCredentials || !$scope.hasPreviousCredentials) &&
          ($scope.form.password.$invalid || $scope.form.host.$invalid))
      )
    }

    function _validForm() {
      var invalidForm = true

      invalidForm =
        $scope.form.name.$invalid ||
        _invalidCredentials() ||
        $scope.model.applications.length === 0 ||
        $scope.form.project.$invalid

      return !invalidForm
    }

    function getIntegration() {
      var promise = $q.defer()
      $scope.loadPromise = promise.promise
      $scope.testing = true
      resetConnection()

      return AgileCentralBugtrackerService.getBugtracker(agileCentralId).then(
        function (data) {
          $scope.showValidConnection = true
          $scope.hasPreviousCredentials = true

          $scope.model =
            AgileCentralBugtrackerService.buildAgileCentralBugtracker(
              data.bugtracker
            )

          $scope.edit = { bugtracker: angular.copy(data.bugtracker) }
          $scope.selected_appids = data.selected_appids

          var request =
            AgileCentralBugtrackerService.buildAgileCentralIntegrationTest(
              $scope.model,
              $scope.hasPreviousCredentials
            )
          request.credentials = undefined

          _getProjects(request, agileCentralId)
            .then(
              function () {
                $scope.properties =
                  AgileCentralBugtrackerService.setupAgileCentralBugtrackerBaseProperties(
                    data.bugtracker,
                    $scope.select
                  )

                if ($scope.properties.owner) {
                  _getUser(
                    request,
                    $scope.properties.owner.ref,
                    AGILE_CENTRAL_PROPERTIES.OWNER,
                    agileCentralId
                  )
                }
                if ($scope.properties.submittedBy) {
                  _getUser(
                    request,
                    $scope.properties.submittedBy.ref,
                    AGILE_CENTRAL_PROPERTIES.SUBMITTED_BY,
                    agileCentralId
                  )
                }

                _getDefectAttributes(request, agileCentralId, promise)
              },
              function (response) {
                resetConnection()
                promise.reject()

                ServiceUtils.handleError(response)
              }
            )
            .finally(function () {
              $scope.testing = false
            })
        },
        function (data) {
          $scope.showInvalidConnection = true
          $scope.testing = false
          promise.reject()

          $scope.error_code = data.errorCode
          $scope.errorMsgs = data.errorMsgs
        }
      )
    }

    function _getProjects(request, id) {
      return AgileCentralBugtrackerService.getProjects(request, id).then(
        function (response) {
          if (response.data && response.data.data.length > 0) {
            $scope.select.projects = response.data.data
          } else {
            $scope.select.projects = []
          }
        }
      )
    }

    function _getEditors(request, keyword, listToUpdate, id) {
      var projectId = AgileCentralBugtrackerService.getObjectIdFromReference(
        $scope.properties.project.ref
      )
      AgileCentralBugtrackerService.getEditors(
        request,
        projectId,
        keyword,
        id
      ).then(function (response) {
        if (response.data && response.data.data.length > 0) {
          $scope.select[listToUpdate] = response.data.data
        } else {
          $scope.select[listToUpdate] = []
        }
      })
    }

    function _getUser(request, ref, fieldToUpdate, id) {
      AgileCentralBugtrackerService.getUser(request, ref, id).then(function (
        response
      ) {
        if (response.data && response.data.data) {
          $scope.properties[fieldToUpdate] = response.data.data
        } else {
          $scope.properties[fieldToUpdate] = undefined
        }
      })
    }

    function _getDefectAttributes(request, id, promise) {
      AgileCentralBugtrackerService.getDefectTypeDefinition(request, id)
        .then(function (response) {
          var defectId = response.data.data.id
          AgileCentralBugtrackerService.getDefectAttributes(
            request,
            defectId,
            id
          )
            .then(function (response) {
              var attributes = response.data.data
              $scope.environmentId = _.find(attributes, {
                name: 'Environment'
              }).id
              $scope.stateId = _.find(attributes, { name: 'State' }).id
              $scope.priorityId = _.find(attributes, {
                name: 'Priority'
              }).id

              _reloadData(request, promise)
            })
            .catch(function (response) {
              ServiceUtils.handleError(response)
              _clearOnFailure(promise)
              $scope.projectSelected = false
            })
        })
        .catch(function (response) {
          ServiceUtils.handleError(response)
          _clearOnFailure(promise)
          $scope.projectSelected = false
        })
    }

    function getApplications() {
      return ApplicationFactory.getApplications('', false, '', '', false)
        .then(function (response) {
          $scope.select.applications = response.data.applications

          var transl = {
            title_allApplications: $translate.instant('title_allApplications')
          }

          allApplications = {
            name:
              transl.title_allApplications +
              ' (' +
              $scope.select.applications.length +
              ')',
            app_id: _allOptionValue
          }
          $scope.model.applications.push(allApplications)
        })
        .catch(ServiceUtils.handleError)
    }

    function save() {
      if ($scope.allowEditCredentials && $scope.hasPreviousCredentials) {
        BugtrackerCredentialsService.openCredentialsActionsModal(
          $scope.forceNewSetCreation
        ).then(function (result) {
          _saveIntegration(result)
        })
      } else {
        _saveIntegration(undefined)
      }
    }

    function _saveIntegration(credentialsActions) {
      $scope.adding = true

      // Check if auto-create is enabled

      var request = AgileCentralBugtrackerService.buildAgileCentralIntegration(
        $scope.model,
        $scope.properties
      )

      // Verify if the credentials are going to be updated
      if (credentialsActions) {
        if (!credentialsActions.isUpdate) {
          request.credentials.name = credentialsActions.name
        }
        request.credentials.credentials_update = credentialsActions.isUpdate
      } else if (request.credentials_id) {
        request.credentials = undefined
      }

      if ($scope.isEdit) {
        updateIntegration(request)
      } else {
        createIntegration(request)
      }
    }

    function createIntegration(request) {
      AgileCentralBugtrackerService.addAgileCentralBugtracker(request).finally(
        function () {
          $scope.adding = false
        }
      )
    }

    function updateIntegration(request) {
      AgileCentralBugtrackerService.editAgileCentralBugtracker(
        agileCentralId,
        request
      ).finally(function () {
        $scope.adding = false
      })
    }

    function cancelCreation() {
      $scope.model = {
        name: '',
        applications: []
      }
      $scope.select = {
        applications: []
      }
      $location.path(UserService.buildUrl('/settings/integration'), true)
    }

    function testConnection() {
      $scope.testing = true
      resetConnection()
      $scope.isUrlTested = true

      $scope.model.host = $scope.model.host.replace(/(\/)$/, '')

      if ($scope.model.credentials && !$scope.model.credentials.id) {
        $scope.forceNewSetCreation = true
        $scope.model.credentialsId = $scope.model.credentials.id
        $scope.model.host = $scope.model.credentials.host
      }

      var request =
        AgileCentralBugtrackerService.buildAgileCentralIntegrationTest(
          $scope.model,
          $scope.hasPreviousCredentials
        )
      var dataLoadingPromise = $q.defer()

      if (!$scope.allowEditCredentials) {
        request.credentials = undefined
      }

      $scope.loadPromise = dataLoadingPromise.promise

      AgileCentralBugtrackerService.testAgileCentralBugtracker(request).then(
        function () {
          $scope.showValidConnection = true
          if (!$scope.isEdit) {
            $scope.model.all_applications = true
          }

          _getProjects(request, agileCentralId)
            .then(
              function () {
                if ($scope.select.projects.length > 0) {
                  // Clear fields related to previous selected project
                  $scope.properties.project = undefined
                  _clearFields()
                }
                _clearOnSuccess(dataLoadingPromise)
              },
              function () {
                resetConnection()
                _clearOnFailure(dataLoadingPromise)
              }
            )
            .catch(function () {
              resetConnection()
              _clearOnFailure(dataLoadingPromise)
            })
        },
        function (data) {
          $scope.showInvalidConnection = true
          _clearOnFailure(dataLoadingPromise)

          $scope.errorCode = data.error_code
          $scope.errorMsgs = data.bugtracker_errors

          if (data.errors) {
            $scope.errorCode = 400
            $scope.fieldErrors = data.errors
          }
        }
      )
    }

    function _clearOnSuccess(promise) {
      $scope.configurationLoaded = true
      $scope.testing = false
      promise.resolve()
    }

    function _clearOnFailure(promise) {
      $scope.testing = false
      promise.reject()
    }

    function _clearFields() {
      $scope.properties.priority_critical = undefined
      $scope.properties.priority_high = undefined
      $scope.properties.priority_medium = undefined
      $scope.properties.priority_low = undefined
      $scope.properties.priority_note = undefined

      $scope.properties.owner = undefined
      $scope.properties.environment = undefined
      $scope.properties.state = undefined
      $scope.properties.submittedBy = undefined
    }

    function _reloadData(request, promise) {
      //close any toast message
      ServiceUtils.logClear()

      $scope.configurationLoaded = true

      if (!$scope.properties.project) {
        var messages = {
          messages: [
            $translate.instant(
              'detail_integrationsSettings_missingProjectKeyError'
            )
          ]
        }
        ServiceUtils.handleError({ data: messages })
        resetConnection()
        promise.reject()
        return
      }

      var dataLoaded = true

      var environmentPromise = AgileCentralBugtrackerService.getAllowedValues(
        request,
        $scope.environmentId,
        agileCentralId
      ).then(
        function (response) {
          if (response.data && response.data.data.length > 0) {
            $scope.select.environments =
              AgileCentralBugtrackerService.removeEmptyValueFromArray(
                response.data.data
              )
          } else {
            $scope.select.environments = []
          }
        },
        function (response) {
          ServiceUtils.handleError(response, errorOptions)
          dataLoaded = false
        }
      )

      var statePromise = AgileCentralBugtrackerService.getAllowedValues(
        request,
        $scope.stateId,
        agileCentralId
      ).then(
        function (response) {
          if (response.data && response.data.data.length > 0) {
            $scope.select.states =
              AgileCentralBugtrackerService.removeEmptyValueFromArray(
                response.data.data
              )
          } else {
            $scope.select.states = []
          }
        },
        function (response) {
          ServiceUtils.handleError(response, errorOptions)
          dataLoaded = false
        }
      )

      var priorityPromise = AgileCentralBugtrackerService.getAllowedValues(
        request,
        $scope.priorityId,
        agileCentralId
      ).then(
        function (response) {
          if (response.data && response.data.data.length > 0) {
            $scope.select.priorities =
              AgileCentralBugtrackerService.removeEmptyValueFromArray(
                response.data.data
              )
          } else {
            $scope.select.priorities = []
          }
        },
        function (response) {
          ServiceUtils.handleError(response, errorOptions)
          dataLoaded = false
        }
      )

      $q.all([environmentPromise, statePromise, priorityPromise]).then(
        function () {
          if (dataLoaded) {
            $scope.properties =
              AgileCentralBugtrackerService.buildAgileCentralBugtrackerBaseProperties(
                $scope.properties,
                $scope.select
              )
            _clearOnSuccess(promise)
            $scope.projectSelected = true
          } else {
            _clearOnFailure(promise)
            $scope.projectSelected = false
          }
        }
      )
    }

    function onChangeProject() {
      var request =
        AgileCentralBugtrackerService.buildAgileCentralIntegrationTest(
          $scope.model,
          $scope.hasPreviousCredentials
        )
      var promise = $q.defer()
      _clearFields()
      $scope.select.users = []

      if (!$scope.allowEditCredentials) {
        request.credentials = undefined
      }

      $scope.loadPromise = promise.promise
      _getDefectAttributes(request, agileCentralId, promise)
    }

    function onUserInputChange(keyword, listToUpdate) {
      if (!keyword) {
        return
      }
      var request =
        AgileCentralBugtrackerService.buildAgileCentralIntegrationTest(
          $scope.model,
          $scope.hasPreviousCredentials
        )

      if (!$scope.allowEditCredentials) {
        request.credentials = undefined
      }
      _getEditors(request, keyword, listToUpdate, agileCentralId)
    }

    function onUserSelect(listToClear) {
      $scope.select[listToClear] = []
    }

    function resetConnection() {
      $scope.configurationLoaded = false
      $scope.showValidConnection = false
      $scope.showInvalidConnection = false
      $scope.isUrlTested = false
      $scope.projectSelected = false
      $scope.errorCode = undefined
      $scope.errorMsgs = []
    }

    function deleteIntegration() {
      integrationService
        .deleteIntegration(
          $scope.model,
          INTEGRATION_TYPE.AGILE_CENTRAL,
          agileCentralId,
          false
        )
        .then(function (deleted) {
          if (deleted) {
            $location.path(UserService.buildUrl('/settings/integration'), true)
          }
        })
    }

    function _getLatestUsedCredentials() {
      BugtrackerCredentialsService.getLatestUsedCredentials(
        INTEGRATION_TYPE.AGILE_CENTRAL
      ).then(
        function (response) {
          if (response.data.success) {
            $scope.model.credentialsId = response.data.credentials.id
            $scope.model.credentials = response.data.credentials
            $scope.model.host = response.data.credentials.host
            $scope.hasPreviousCredentials = true
            testConnection()
          }
        },
        function (response) {
          ServiceUtils.handleError(response, errorOptions)
          $scope.hasPreviousCredentials = false
        }
      )
    }

    function manageCredentials() {
      $scope.credentialsListPromise =
        BugtrackerCredentialsService.getCredentialsList(
          INTEGRATION_TYPE.AGILE_CENTRAL
        ).then(
          function (response) {
            $scope.select.credentials = response.data.credentialsList
            $scope.credentialsSelect = true

            resetConnection()

            // Init editable fields
            $scope.model.username = $scope.model.credentials.username
            $scope.model.host = $scope.model.credentials.host
            $scope.model.password = ''
          },
          function (response) {
            ServiceUtils.handleError(response, errorOptions)
          }
        )
    }

    function onChangeCredentials() {
      if ($scope.model.credentialsId !== $scope.model.credentials.id) {
        resetConnection()
        $scope.model.credentialsId = $scope.model.credentials.id
        $scope.model.username = $scope.model.credentials.username
        $scope.model.host = $scope.model.credentials.host
      }
      // Update editable fields
      integrationService.updateEditableFields($scope)
    }

    function onCredentialsInputChange() {
      $scope.allowEditCredentials = true
      resetConnection()
    }

    function onUrlSelectChange(select) {
      integrationService.onUrlSelectChange(select)
    }

    init()
  }
})()
